import { Box, Avatar, Badge, IconButton, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { useTranslation } from 'react-i18next';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { colors } from '../core/theme/theme';

export const MOBILE_TOP_BAR_HEIGHT = 56;

interface Props {
  title: string;
  unreadCount: number;
  onAvatarClick: () => void;
  userInitials: string;
  avatarSrc?: string;
}

export default function MobileTopBar({ title, unreadCount, onAvatarClick, userInitials, avatarSrc }: Props) {
  const { t } = useTranslation();
  return (
    <Box
      component="header"
      sx={{
        position: 'sticky',
        top: 0,
        height: MOBILE_TOP_BAR_HEIGHT,
        bgcolor: '#FFFFFF',
        borderBottom: `1px solid ${colors.lightGray}`,
        display: 'flex',
        alignItems: 'center',
        px: 2,
        gap: 1,
        zIndex: 1100,
      }}
    >
      <Typography variant="h3" component="h1" sx={{ flex: 1, fontSize: 20, fontWeight: 700, m: 0 }} noWrap>
        {title}
      </Typography>
      <IconButton
        component={RouterLink}
        to="/notifications"
        aria-label={t('nav.notifications')}
        sx={{ borderRadius: 0, minWidth: 44, minHeight: 44 }}
      >
        <Badge
          badgeContent={unreadCount}
          color="error"
          sx={{ '& .MuiBadge-badge': { borderRadius: '6px', fontWeight: 700 } }}
        >
          <NotificationsOutlinedIcon />
        </Badge>
      </IconButton>
      <IconButton
        onClick={onAvatarClick}
        aria-label={t('nav.profile')}
        sx={{ borderRadius: 0, minWidth: 44, minHeight: 44, p: 0.5 }}
      >
        <Avatar
          src={avatarSrc}
          sx={{ width: 28, height: 28, borderRadius: 0, bgcolor: colors.lightGray, color: colors.bodyText, fontSize: 12, fontWeight: 700 }}
        >
          {userInitials}
        </Avatar>
      </IconButton>
    </Box>
  );
}
